// Firebase SDK initialization (singleton).
// All Firebase Auth calls in the app should import { auth } from here.
import { initializeApp, getApps } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  GoogleAuthProvider,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseApp =
  getApps()[0] || initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);

// Sessions persist across reloads/tabs (matches old localStorage behaviour).
setPersistence(auth, browserLocalPersistence).catch((e) => {
  // Non-fatal: persistence will fall back to in-memory.
  console.warn('Firebase auth persistence failed:', e?.message);
});

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
